import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import PropertiesAndNames from './PropertiesAndNames';
import MainOrderDetails from './MainOrderDetails';
import Searches from './Searches';
import Documents from './Documents';
import Button from '../../components/Button';
import {  useOrderEntry } from './OrderEntryContext';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import TopBar from '../Home/TopBar';
import { useUserContext } from '../../context/UserContext';
import { useSearchParams } from '../../context/SearchParamsContext';
import PropertyErrorModal from './PropertiesAndNames/PropertyErrorModal';

const OrderEntryLayout = styled.div`
  margin-top: 50px;
`;

const OrderEntry = () => {
  const { submitOrder, submitting, titleNumber, openErrorModal, setOpenErrorModal, setOpenSellerErrorModal, openSellerErrorModal } = useOrderEntry();
  const [showleaveModal, setShowLeaveModal] = useState(false);
  const userContext = useUserContext();
  const searchParams = useSearchParams();
  const clientName = userContext.user.clientName;
  const history = useHistory();
  const headerSearch = () => {
    const queryString = qs.stringify({
      open: searchParams.isTopSearchOpen ? 1 : 0,
      query: searchParams.topSearchText,
    });
    document.title = '';
    history.push(`/home?${queryString}`);
  };
  const closeDetailsSearch = () => {
    searchParams.setTopSearchText('')
    searchParams.setIsTopSearchOpen(false);
  };
  const setupBeforeUnloadListener = () => {
    window.addEventListener('beforeunload', ev => {
      ev.preventDefault();
      ev.returnValue = '';
    });
  };
  useEffect(() => {
    // setupBeforeUnloadListener();
  }, []);
  useEffect(() => {
    if (titleNumber && !showleaveModal)
    {
        setShowLeaveModal(true)
    }
  }, [titleNumber]);
  return (
    <>
      <TopBar
        search={headerSearch}
        searchText={searchParams.topSearchText}
        onSearchTextChange={searchParams.setTopSearchText}
        setSearchOpen={searchParams.setIsTopSearchOpen}
        searchOpen={searchParams.isTopSearchOpen}
        info
        name={clientName}
        closeSearch={closeDetailsSearch}
        showLeaveModal={showleaveModal}
      />
       <PropertyErrorModal
        buttonText="Ok"
        info="A property must be added before the order can be submitted."
        onClose={() => setOpenErrorModal(false)}
        open={openErrorModal}
      />
      {/* <PropertyErrorModal
        buttonText="Ok"
        info="A seller name or note must be entered."
        onClose={() => setOpenSellerErrorModal(false)}
        open={openSellerErrorModal}
      /> */}
      <OrderEntryLayout>
        <MainOrderDetails />
        <PropertiesAndNames />
        <Searches />
        <Documents />
        <div
          style={{
            width: 1160,
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: 32,
            marginTop: 32,
          }}
        >
          <Button disabled={submitting} onClick={()=>{setShowLeaveModal(false); submitOrder()}} buttonType="ButtonPrimaryMedium" buttonText="Submit Order" loadingStatus={submitting}/>
        </div>
      </OrderEntryLayout>
    </>
  );
};

export default OrderEntry;
